/* eslint-disable @typescript-eslint/no-explicit-any */

import { SvgIcon } from '@mui/material';

export const WmsIcon = (props: any) => {
  return <SvgIcon component={props.icon} {...props} />;
};
